/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Reset state saga
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.1.0
 */

import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestSaga } from '@/main/sagas/requestSaga';
import { API_HOSTNAME, RESET_BASKET } from '@modules/app/Api';

import { dropTableFilterAndSort, resetBasketSuccess } from '../actions/tableActions';
import { MapTableNameToProxyApiPath } from '../types/tableMapTypes';
import { EResetBasketType } from '../types/tableTypes';
import type { TResetBasketAction } from '../types/tableTypes';

export function* callProxySaga({ payload }: TResetBasketAction): SagaIterator {
    const apiPath = MapTableNameToProxyApiPath[payload.tableName];
    if (!apiPath) return;

    try {
        //resetBasket
        const queryParams = [`resetBasket=${!!payload.resetBasket}`];
        // resetFilter
        payload.resetFilter === false && queryParams.push('resetFilter=false');
        // resetState
        payload.resetState === false && queryParams.push('resetState=false');
        // id
        payload.id && queryParams.push('id=' + payload.id);
        payload.context && queryParams.push(`context=${payload.context}`)

        const queryString = queryParams.join('&');
        const url = API_HOSTNAME + apiPath + RESET_BASKET + `?${queryString}`;
        yield call(requestSaga, url, 'GET');
    } catch (e) {
        console.error(e);
    }
    if (payload.type === EResetBasketType.CLEAR_FILTER) {
        yield put(dropTableFilterAndSort({ tableName: payload.tableName }));
    }
    yield put(resetBasketSuccess());
}
